import React from "react"
import Politika from "../components/Politika"

export default function PolitikaKonfidenczialnosti() {
  return <Politika />
}
